const storeTheme = {
    "--z-index-chat-window": "120",
    "--primary-color": "#E13205",
    "--secondary-color": "#F088B6",
    "--agent-message-fg-color": "#3A3A3A",
    "--agent-message-bg-color": "#F6F6F6",
    "--agent-typing-indicator-bg-color": "#F6F6F6",
    "--agent-typing-indicator-fg-color": "#3A3A3A",
    "--launch-button-bg-color": "#FCECE7",
    "--launch-button-width": "2.5rem",
    "--launch-button-height": "2.5rem",
    "--launch-button-bottom": "1.875rem",
    "--launch-button-right": "1.875rem",
    "--header-fg-color": "#3F3F40",
    "--system-message-fg-color": "#6C757D",
    "--user-message-bg-color": "#FCECE7",
    "--user-message-fg-color": "#3A3A3A",
    "--bot-message-bg-color": "#F6F6F6",
    "--bot-message-fg-color": "#3A3A3A",
    "--text-link-color": "#CF2E05", 
    "--text-link-hover-color": "#F088B6",
    "--text-link-decoration": "none",
    "--text-link-hover-decoration": "none",
    "--uploadicon-fg-color": "#3A3A3A",
    "--primary-font": "ICA Text",
    "--font-family": "'ICA Text Ny', 'ICA Text', Arial, Helvetica, sans-serif",
    "--font-family-heading": "'ICA Rubrik', Arial, Helvetica, sans-serif",
    "--send-button-bg-color": "#EB1F07",
    "--send-button-hover-bg-color": "#F088B6",
    "--send-button-active-bg-color": "#F088B6",
    "--button-bg-color": "#FFFFFF",
    "--button-fg-color": "#CF2E05",
    "--button-border-color": "#CF2E05",
    "--button-bg-color-hover": "#F088B6",
    "--button-fg-color-hover": "#FFFFFF",
    "--button-border-color-hover": "#F088B6",
    "--close-modal-button-border-color": "#CF2E05",
    "--close-modal-button-bg-color": "#CF2E05",
    "--close-modal-button-fg-color": "#FFFFFF"
};
export default storeTheme;